import { yupResolver } from '@hookform/resolvers/yup';
import { Button } from '@src/common/components/button/Button';
import { PageLayout } from '@src/common/components/Page';
import { Stack } from '@src/common/components/Stack';
import { TextInput } from '@src/common/components/TextInput';
import { theme } from '@src/common/styles/Theme';
import { AddUserFormInputs } from '@src/manageUsers/AddUserFormInputs';
import { useUserCreation } from '@src/manageUsers/hooks/useUserCreation';
import type { SubmitHandler } from 'react-hook-form';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

export const AddUser = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { createUser, isLoading } = useUserCreation({
    onSuccess: () => {
      navigate('/users');
    },
  });

  const {
    register,
    formState: { errors },
    handleSubmit,
  } = useForm({
    resolver: yupResolver(AddUserFormInputs),
  });

  const submitUser: SubmitHandler<AddUserFormInputs> = ({
    name,
    email,
    extension,
  }) => {
    createUser({ name, email: email.toLowerCase(), extension });
  };

  return (
    <PageLayout title={t('addUser')}>
      <form onSubmit={handleSubmit(submitUser)}>
        <Stack
          direction="column"
          alignItems="stretch"
          width="400px"
          gap={theme.spacing['3']}
        >
          <TextInput
            label={t('name')}
            error={errors.name && t(`formErrors.${errors.name.message}`)}
            {...register('name')}
          />

          <TextInput
            label={t('email')}
            error={errors.email && t(`formErrors.${errors.email.message}`)}
            {...register('email')}
          />
          <TextInput
            label={t('extension')}
            error={
              errors.extension && t(`formErrors.${errors.extension.message}`)
            }
            {...register('extension')}
          />

          <Stack direction="row" justifyContent="center">
            <Button disabled={isLoading} type="submit">
              {t('create')}
            </Button>
          </Stack>
        </Stack>
      </form>
    </PageLayout>
  );
};
